/**
 * Generic API Mutation Hook
 */
import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import type { ApiResponse, ApiError } from '../types';

export type MutationOptions<
  TData = any,
  TError = ApiError,
  TVariables = void,
  TContext = unknown
> = {
  mutationFn: (variables: TVariables) => Promise<ApiResponse<TData>>;
} & Omit<
  UseMutationOptions<ApiResponse<TData>, TError, TVariables, TContext>,
  'mutationFn'
>;

export function useApiMutation<
  TData = any,
  TError = ApiError,
  TVariables = void,
  TContext = unknown
>(
  options: MutationOptions<TData, TError, TVariables, TContext>
): UseMutationResult<ApiResponse<TData>, TError, TVariables, TContext> {
  // Type assertion needed because service methods return specific ApiResponse subtypes
  // which are compatible with ApiResponse<TData>
  return useMutation<ApiResponse<TData>, TError, TVariables, TContext>({
    ...options,
    mutationFn: options.mutationFn as any,
  });
}

